import { render, staticRenderFns } from "./CountryPreview.vue?vue&type=template&id=b2c25822&"
import script from "./CountryPreview.vue?vue&type=script&lang=js&"
export * from "./CountryPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports